<script setup>

defineProps(['is', 'inverted']);
</script>

<template>
    <component :is="is"
               :class="inverted ? 'py-1 text-black bg-white border-transparent hover:bg-gray-200 focus:bg-gray-200 active:bg-gray-200' : 'py-2 font-semibold text-white bg-gray-800 border border-transparent hover:bg-gray-700 focus:bg-gray-700 active:bg-gray-900'"
               class="inline-flex items-center justify-center text-center px-4 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition ease-in-out duration-150"
    >
        <slot/>
    </component>
</template>
